import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=5cfa3fc1&"
import script from "./InstagramFeed.vue?vue&type=script&lang=js&"
export * from "./InstagramFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports